import React from "react";
import Layout from "../../Layout/Layout";
const Private = () => {
  return (
    <>
      <Layout />
    </>
  );
};

export default Private;
